import PropTypes from 'prop-types'
import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'

import TextField from '../../FormLegacy/FormFieldsV2/TextField'
import api from '../../../api/api'

const CommunityCode = ({ formState, setFormState, setStep }) => {
  const { t } = useTranslation(['auth', 'common'])
  const validationSchema = Yup.object().shape({
    communityCode: Yup.string().required(t('auth:communityCode.required')),
  })

  const [error, setError] = React.useState(null)
  const navigate = useNavigate()

  const onSubmit = (values) => {
    api
      .verifyCommunityCode(values.communityCode)
      .then(() => {
        setFormState((prev) => ({ ...prev, communityCode: values.communityCode }))
        setStep('password')
      })
      .catch(() => {
        setError(t('auth:communityCode.error'))
      })
  }

  return (
    <Formik
      initialValues={{
        communityCode: formState.communityCode,
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ handleSubmit, values, handleChange, touched, errors, setFieldTouched }) => (
        <form onSubmit={handleSubmit} className="auth__form">
          <button type="button" className="auth__back-button" onClick={() => navigate('/login')}>
            <ArrowLeft size={20} />
            {t('common:actions.back')}
          </button>
          <p className="auth__step-description">{t('auth:communityCode.description')}</p>
          <TextField
            type="text"
            name="communityCode"
            label={t('auth:communityCode.label')}
            placeholder={t('auth:communityCode.placeholder')}
            value={values.communityCode}
            onChange={handleChange}
            isError={touched.communityCode && !!errors.communityCode}
            onBlur={() => setFieldTouched('communityCode')}
          />
          {error && <p className="error auth__form__description">{error}</p>}
          <button type="submit" className="button button-primary">
            {t('auth:shared.next')}
          </button>
        </form>
      )}
    </Formik>
  )
}

CommunityCode.propTypes = {
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
}

export default CommunityCode
